<script>
/**
 * ****************************************************************************
 * @description     :   Header
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const Header = {
    name: 'Header',
    template: template,
    watch: {
        isShowMenu() {
            if (this.isShowMenu === true) {
                window.addEventListener('keyup', this.onEscapeKeyUp);
            } else {
                window.removeEventListener('keyup', this.onEscapeKeyUp);
            }
        }
    },
    computed: {
        ...mapState('app', ['user', 'header', 'isShowMenu', 'isMobile'])
    },
    mounted() {
        var menuUser = document.getElementById('dropdownUser2');
        if (menuUser) {
            menuUser.classList.remove('show');
            menuUser.setAttribute('aria-expanded', 'false');
        }
    },
    methods: {
        ...mapMutations('app', ['showMenu', 'hideMenu', 'setLogout']),
        onEscapeKeyUp(event) {
            if (event.which === 27) {
                console.log('close event');
                this.hideMenu();
            }
        },
        toggleMenu: function () {
            if (this.isShowMenu) {
                this.hideMenu();
            } else {
                this.showMenu();
            }
        },
        logout: function () {
            this.setLogout(true);
            this.$router.push('/bs/bs001000i');
        }
    }
};
export default Header;
</script>
